import React from "react";
import "./Footer1.css";

const Footer1 = () => {
  return (
    <div className="footer1">
      <h1 className="footer1_title">
        Now Refer & Earn ₹500 for every referral*
      </h1>
      <p className="footer1_message">* Terms and conditions will be applied</p>
    </div>
  );
};

export default Footer1;
